<template>
  <div class="sidebar">
    <ul>
      <li v-for="item of list" :key="item.cat_id" @click="select(item.cat_id, 2)" :class="activeIndex === item.cat_id ? 'select' : ''">
        {{ item.cat_name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number
    }
  },
  data () {
    return {
    }
  },
  methods: {
    select (id) {
      this.$emit('seleced', id)
    },
  },
}
</script>
<style lang="scss" scoped>
.sidebar {
  font-size: 0.28rem;
  position: fixed;
  left: 0;
  background: #eee;
  // width: 100%;

  ul {
    overflow-y: scroll;
    height: 85vh;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));

    // padding: 0.1rem 0.2rem;
    li {
      width: 25vw;
      padding: 0.3rem 0.2rem;
      font-size: 0.3rem;
      text-align: center;
    }
  }

  .select {
    color: $globalcolor;
    font-weight: 800;
    font-size: 0.35rem !important;
    position: relative;
    background: #fff;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 0.2rem;
      height: 100%;
      background: $globalcolor;
    }
    &:after {
      content: '';
      position: absolute;
      right: 0rem;
      top: -5%;
      width: 0.1rem;
      height: 100%;
      background: #ffffff;
      border-radius: 25px 0px 0px 15px;
    }
  }
}
</style>
